module.exports = "<h2>\n  404 - Page not found\n</h2>\n<p *ngIf=\"path\">You might want to go to the <a [routerLink]=\"path\">\"{{ path }}\" page</a></p>\n"